import { render, staticRenderFns } from "./ComponentSMSDetail.vue?vue&type=template&id=6a80056a&"
import script from "./ComponentSMSDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentSMSDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports